module.exports = __webpack_public_path__ + "static/media/whatsapp.6db49ff4.png";